import React from "react";

const ColorDivisonSelector = (props) => {
    let [division, setDivision] = React.useState(props.division);
    return <div>
        <input style={{
            padding: 4,
            width: 50,
        }} type={'number'} value={division} onChange={(e)=>{
            try{
                let _d = e.target.value;
                if(_d==='')
                    _d='0';
                _d = parseInt(_d);
                if(_d<=0){
                    _d=2;
                }
                if(_d>=15){
                    _d=15
                }
                setDivision(_d)
                props.onChange(_d)
            }catch(e){
                console.log(e)
            }
        }} />
    </div>
}


export default ColorDivisonSelector;